import { createSlice } from "@reduxjs/toolkit"
import { stateEnum } from "../constants/enum.js"

const { menuMaster } = stateEnum

const initialState = {  
  selectedMenu: {},
}
   

const menuMasterSlice = createSlice({
  name: menuMaster,
  initialState,
  reducers: {
    resetMenuMaster: (state) => { 
      state.selectedMenu = {}
    },
    setSelectedMenu: (state, action) => {
      state.selectedMenu = action.payload
    },
  }, 
})

export const { resetMenuMaster, setSelectedMenu } = menuMasterSlice.actions
export default menuMasterSlice.reducer
